module.exports = __webpack_public_path__ + "img/gou.cd732a76.svg";